import { loadModules } from 'esri-loader';

import { IImageryLayer } from '../types/timeline';
import { ERasterAnalysis } from '../types/layers';

export const createRaster = async (rasterType: string, imageId: number, imageLayer: number) => {
  const [RasterFunction] = await loadModules(['esri/layers/support/RasterFunction']);

  const functionArguments =
    IImageryLayer[imageLayer] === 'landsat'
      ? landsatFunctionArguments(rasterType)
      : sentinelFunctionArguments(rasterType);

  const raster = new RasterFunction({
    functionName: 'BandArithmetic',
    functionArguments: {
      Raster: `$${imageId}`, // OID of image from service
      ...functionArguments,
    },
    variableName: 'Raster',
  });
  return raster;
};

const landsatFunctionArguments = (rasterType: string) => {
  const { EVI, GNDVI, SAVI, NDVI } = ERasterAnalysis;

  switch (rasterType) {
    case NDVI:
      return { Method: 1, BandIndexes: '5 4' };
    case GNDVI:
      return { Method: 0, BandIndexes: '(B5 - B3) / (B5 + B3)' };
    case SAVI:
      return { Method: 2, BandIndexes: '5 4 0.5' };
    case EVI:
      return {
        Method: 0,
        BandIndexes: '2.5 * ((B5 - B4) / (B5 + 6 * B4 - 7.5 * B2 + 1))',
      };
    default:
      console.log('No Raster Function for', rasterType);
  }
};

const sentinelFunctionArguments = (rasterType: string) => {
  switch (rasterType) {
    case 'NDVI':
      return { Method: 1, BandIndexes: '8 4' };
    case 'GNDVI':
      return { Method: 0, BandIndexes: '(B8 - B3) / (B8 + B3)' };
    case 'SAVI':
      return { Method: 2, BandIndexes: '8 4 0.5' };
    case 'EVI':
      return {
        Method: 0,
        BandIndexes: '(2.5 * (B8 - B4)) / (B8 + (2.4 * B4) + 10000)',
      };
    default:
      console.log('No Raster Function for', rasterType);
  }
};
